<script setup lang="ts">
import { DropdownMenuItem, DropdownMenuSub, DropdownMenuSubTrigger, DropdownMenuSubContent } from '@/components/dropdown-menu'
import type { MenuItemType } from './types'
import { useRouter } from 'vue-router'

const props = defineProps({
  item: {
    type: Object as () => MenuItemType,
    required: true
  }
})

const router = useRouter()

const handleAction = (item: MenuItemType) => {
  if (item.action) {
    item.action()
  }
}
</script>

<template>
  <!-- Router link item -->
  <DropdownMenuItem as-child
    v-if="item.isRouterLink && item.route" 
    @click="handleAction(item)"
    class="px-3"
  >
    <router-link :to="item.route">{{ item.label }}</router-link>
  </DropdownMenuItem>
  
  <!-- Submenu item with nested items -->
  <DropdownMenuSub v-else-if="item.submenuItems && item.submenuItems.length > 0">
    <DropdownMenuSubTrigger class="px-3 justify-between">
      {{ item.label }}
      <template #icon>
        <span class="material-icons-round">arrow_right</span>
      </template>
    </DropdownMenuSubTrigger>
    <DropdownMenuSubContent class="w-40 px-0 py-2" data-testid="dropdown-menu-sub-content">
      <!-- Recursive component usage for each submenu item -->
      <template v-for="(subItem, subIndex) in item.submenuItems" :key="subIndex">
        <NestedMenuItem 
          v-if="subItem.submenuItems && subItem.submenuItems.length > 0"
          :item="subItem"
        />
        <DropdownMenuItem 
          v-else
          @click="handleAction(subItem)" 
          class="px-3"
        >
          {{ subItem.label }}
        </DropdownMenuItem>
      </template>
    </DropdownMenuSubContent>
  </DropdownMenuSub>
  
  <!-- Regular menu item -->
  <DropdownMenuItem 
    v-else
    @click="handleAction(item)"
    class="px-3"
  >
    {{ item.label }}
  </DropdownMenuItem>
</template>
